export const md = 768;
export const lg = 992;